import * as React from 'react';
import {loadModules} from 'esri-loader';

export default class ArrowMarker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            graphic: null
        };
        this.timer = null;
        this.tryCount = 3;
    }

    render() {
        return null;
    }

    componentDidMount() {
        loadModules([
            'esri/Graphic',
            'esri/geometry/SpatialReference'
        ]).then(([
            Graphic,
            SpatialReference,
        ]) => {
            const props = this.props;
            if (isNaN(props.x) || isNaN(props.y)) return;

            let point = {
                type: "point", // autocasts as new Polygon()
                longitude: this.props.x,
                latitude: this.props.y,
                spatialReference: new SpatialReference(this.props.wkid ? this.props.wkid : 3301)
            };

            let symbol = {
                type: "simple-marker",
                color: [31, 31, 255, 0.5],
                path: "m0.5,50.5l90,-50l9,9.5l-79.5,40.5l80,39.5l-10,10.5l-89.5,-50z",
                size: "15px",
                angle: 180 - (props.angle ? props.angle : 0) * 1.15,
                outline: {
                    width: '1px',
                    color: [31, 31, 255, 0.5],
                },
            };

            // Add the geometry and symbol to a new graphic
            const graphic = new Graphic({
                geometry: point,
                symbol: symbol
            });

            this.setState({graphic});

            if (this.props.layerId) {
                const layer = this.props.map.findLayerById(this.props.layerId);
                if (layer)
                    layer.graphics.add(graphic);
                else
                    this.timer = setInterval(() => {this.addGraphic(graphic);}, 1000);
            } else {
                this.props.view.graphics.add(graphic);
            }
        }).catch((err) => console.error(err));
    }

    addGraphic = (graphic) => {
        const layer = this.props.map.findLayerById(this.props.layerId);
        if (layer) {
            layer.graphics.add(graphic);
            clearInterval(this.timer);
            this.timer = null;
        } else {
            this.tryCount--;
        }
        if (this.tryCount < 1) {
            clearInterval(this.timer);
            this.timer = null;
            console.error('Cannot add graphic to map');
        }
    };

    componentWillUnmount() {
        if (this.props.layerId) {
            const map = this.props.map,
                layer = (map) ? map.findLayerById(this.props.layerId) : null;
            if (layer && layer.graphics) {
                layer.graphics.remove(this.state.graphic);
            }
        } else {
            this.props.view.graphics.remove(this.state.graphic);
        }
    }
}
